var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-container',[_c('v-row',_vm._l((_vm.legalNews),function(legalNew){return _c('v-col',{key:legalNew.name + legalNew.date,attrs:{"cols":"3"}},[_c('news-card',{attrs:{"legalNew":legalNew}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }